import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import GeneralAuthentication from "../general/GeneralAuthentication";

import { PossibleNaviationPages } from "./Navigation";
import { activateNavigationPage } from "../store/components";
import Dropzone from "react-dropzone";
import * as theme from "../theme";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Form from "react-bootstrap/Form";
import { getUserDetails, deleteUserImg } from "../store/userManagement";
import CancelIcon from "@material-ui/icons/Cancel";
import { toast } from "react-toastify";
import { getBrokerInformation } from "../store/broker";
import translations from "../utils/translations";

const UploadBrokerImage = (props) => {
  const selecteduser = props.selecteduser;
  const user = props.user;
  const setSelecteduser = props.setSelecteduser;
  const broker = props.broker;
  const previewCanvasRef = props.previewCanvasRef;
  const dispatch = useDispatch();

  const brokerInfo = useSelector(getBrokerInformation);

  const languagepreference = brokerInfo.information.languagepreference;

  const userImageUploadTranslations =
    translations[languagepreference].userImageUpload;

  useEffect(() => {
    dispatch(
      activateNavigationPage({ pagecode: PossibleNaviationPages.mypolicies })
    );
  }, [dispatch]);

  const dropzoneStyle = {
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
  };
  //   const previewCanvasRef = useRef(null);
  const [imgCheckboxText, setimgCheckboxText] = useState(
    userImageUploadTranslations.cropImage
  );
  const [crop, setCrop] = useState({
    unit: "px",
    width: 225,
    minWidth: 225,
    maxWidth: 225,
    height: 217,
  });
  const [upImg, setUpImg] = useState();
  const imgRef = useRef(null);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [imgCheckbox, setimgCheckbox] = useState(false);
  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);
  const checkselectfile = (files) => {
    console.log(files[0]);
    const reader = new FileReader();
    reader.addEventListener("load", () => setUpImg(reader.result));
    reader.readAsDataURL(files[0]);
  };
  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;

    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";
    if (imgCheckbox) {
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );
      setimgCheckboxText(userImageUploadTranslations.cropImage);
    } else {
      setimgCheckboxText(userImageUploadTranslations.fitToSize);
      canvas.width = 304;
      canvas.height = 304;
      var ratioX = canvas.width / image.naturalWidth;
      var ratioY = canvas.height / image.naturalHeight;
      var ratio = Math.min(ratioX, ratioY);
      ctx.drawImage(
        image,
        0,
        0,
        image.naturalWidth * ratio,
        image.naturalHeight * ratio
      );
    }
  }, [completedCrop, imgCheckbox]);
  return (
    <div className="image-section">
      <div className="form-group row">
        <label className="col-sm-3 col-form-label">
          {" "}
          {userImageUploadTranslations.imageUpload}
        </label>
        <div className="col-sm-9">
          <div>
            <Dropzone
              onDrop={(files) => checkselectfile(files)}
              accept="image/*"
              multiple={false}
            >
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p style={dropzoneStyle}>
                      {userImageUploadTranslations.dropzoneText}
                    </p>
                  </div>
                </section>
              )}
            </Dropzone>
          </div>
          <br />
          {upImg ? (
            <div>
              <ReactCrop
                src={upImg}
                onImageLoaded={onLoad}
                crop={crop}
                onChange={(c) => setCrop(c)}
                onComplete={(c) => setCompletedCrop(c)}
                locked={true}
              />

              <br />
              <Form.Check
                inline
                label={imgCheckboxText}
                name="group1"
                type="checkbox"
                id={`inline-checkbox-1`}
                onClick={(e) => {
                  setimgCheckbox(e.target.checked);
                }}
              />
              <p> {userImageUploadTranslations.imagePreview}</p>
              <div>
                <canvas
                  ref={previewCanvasRef}
                  // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                  style={{
                    width: Math.round(completedCrop?.width ?? 0),
                    height: Math.round(completedCrop?.height ?? 0),
                  }}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="form-group row">
        <label className="col-2">
          {" "}
          {userImageUploadTranslations.currentImage}
        </label>
        <div className="col-1"></div>
        {typeof selecteduser.uImage === "undefined" ||
        selecteduser.uImage == null ? (
          userImageUploadTranslations.noImage
        ) : selecteduser.uImage == "" ? (
          userImageUploadTranslations.noLogo
        ) : (
          <div className="image">
            <img src={selecteduser.uImage} alt="current logo" />
            <div
              className="delete"
              type="button"
              onClick={() => {
                console.log(user);
                dispatch(deleteUserImg(user)).then(() => {
                  setSelecteduser({
                    ...selecteduser,
                    uImage: null,
                  });
                  dispatch(
                    getUserDetails(broker.information.brokerages[0].code)
                  );
                  toast.success(userImageUploadTranslations.userDetailsUpdated);
                });
              }}
            >
              <CancelIcon />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadBrokerImage;
